export const getLoading = state => state.loading;
export const getCurrent = state => state.currentPage;
export const getHeaderStatus = state => state.headerStatus;
export const getEntraMenus = state => state.entraMenus;
